import { PRINT_LABEL_DESIGN_ENUMS } from "../system/globalEnums";
import { EMPTY_STRING } from "./general.constant";
import { routesPathConstants } from "./routesPath.constant";

//-------Export Global Constants
export const globalConstants = {
  DAILY: "Daily",
  MONTHLY: "Monthly",
  YEARLY: "Yearly",
  CUSTOM: "Custom",
  ALL: "All",
  ALL_STORES: "All Stores",
  LARGE_SCREEN_SIZE: 1920,
  EMPTY_OBJECT: {},
  REQUEST: "_REQUEST",
  SUCCESS: "_SUCCESS",
  FAILURE: "_FAILURE",
  SORT: {
    ASC: "asc",
    DESC: "desc",
  },
  DRAFT: "Draft",
  CASH: "cash",
  OTHER: "other",
  CREDIT: "storeCredit",
  GIFT_CARD: "giftCard",
  CREDIT_CARD: "creditCard",
  TYPE_ID_TRD: "TRD",
  TYPE_ID_TRA: "TRA",
  TYPE_RETURN: "RET",
  DEFAULT_ENDDATE: "2099-12-03T03:16:17.652Z",
  MAX_LENGTH_OF_PRODUCT_TITLE: 35,
  MAX_LENGTH_OF_PRODUCT_CATEGORY: 12,
  COMPANY_DOMAIN_URL: "COMPANY_DOMAIN_URL",

  NOT_CONFIGURED: "Not Configured",
  SHOPIFY: "shopify",
};

export const gridSortingConstants = {
  DEFAULT: "",
  ACTIVE: "active",
  ASCENDING: "asc",
  DESCENDING: "desc",
  INACTIVE: "inactive",
};

export const countryCodesConstants = {
  USA: "US",
  CANADA: "CA",
};

export const defaultGridState = {
  pageIndex: 1,
  pageNumber: 1,
  totalRecords: 0,
  searchQuery: "",
  pageEndRecordNumber: 0,
  pageStartRecordNumber: 0,
  pageSizeOptions: [10, 20, 50, 100, 500],
  sortFilter: EMPTY_STRING,
  pageSize: process.env.REACT_APP_GRID_PAGE_SIZE,
  filters: "",
};

export const defaultGridStateDataTable = {
  pageSize: 50,
  pageIndex: 0,
  sortBy: [],
};

export const defaultSaleProductsState = {
  pageIndex: 1,
  totalRecords: 0,
  searchQuery: "",
  pageEndRecordNumber: 0,
  pageStartRecordNumber: 0,
  sortFilter: EMPTY_STRING,
  category: EMPTY_STRING,
  productType: EMPTY_STRING,
  subcategory: EMPTY_STRING,
  pageSize: process.env.REACT_APP_GRID_PAGE_SIZE,
};

export const IMAGE_FILE_TYPES = {
  PNG: "image/png",
  JPG: "image/jpg",
  JPEG: "image/jpeg",
};

export const LOCK_TYPE = {
  UPDATE_INVENTORY_PRESET: "UPDATE_INVENTORY_PRESET",
  DISABLE_SHOPIFY_INTEGRATION: "DISABLE_SHOPIFY_INTEGRATION",
  UPDATE_INVENTORY_AUDIT: "UPDATE_INVENTORY_AUDIT",
};

export const toggleSwitchButtonConstants = {
  SHOW_ON_LABEL: "showOnLabels",
  SHOW_ON_RECEIPT: "showOnReceipt",
  IS_OUTLET_TRACKING: "isOutletTracking",
  IS_SALE_OUT_OF_STOCK: "isSaleOutOfStock",
  IS_ID_REQUIRED_TRADE_IN: "isIdForTradein",
  IS_CASH_TRACKING_ENABLED: "isCashTracking",
  IS_AUTO_PRINT_RECEIPT: "isAutoPrintReceipt",
  IS_QR_CODE_ON_SALE_RECEIPT: "isQrCodeOnSaleReceipt",
  IS_QR_CODE_ON_TRADE_RECEIPT: "isQrCodeOnTradeReceipt",
  IS_SERIAL_NUMBER_REQUIRED_INVENTORY: "isSerialNumber",
  IS_AUTO_PRINT_TRADE_RECEIPT: "isAutoPrintTradeReceipt",
  ALWAYS_USE_STOCK_PRICE_FOR_COGS: "alwaysUseStockPriceForCogs",
  IS_ID_REQUIRED_TRADE_IN_STORE_CREDIT: "isIdForTradeinStoreCredit",
  APPLY_STORE_CREDIT_PAYMENTS_AS_PRE_TAX: "applyStoreCreditPaymentsAsPreTax",
  IS_ITEMIZED_BREAKDOWN_ON_TRADE_RECEIPT: "isItemizedBreakDownForTradeReceipt",
};

//------- Print Label Design Options for Print label modal
export const PRINT_LABEL_DESIGN_OPTIONS = [
  {
    value: PRINT_LABEL_DESIGN_ENUMS.STANDARD.value,
    label: PRINT_LABEL_DESIGN_ENUMS.STANDARD.label,
  },
  {
    value: PRINT_LABEL_DESIGN_ENUMS.MINIMAL.value,
    label: PRINT_LABEL_DESIGN_ENUMS.MINIMAL.label,
  },
  {
    value: PRINT_LABEL_DESIGN_ENUMS.ALTERNATE.value,
    label: PRINT_LABEL_DESIGN_ENUMS.ALTERNATE.label,
  },
];

export const CONSOLE_LOGS_TYPES = {
  LOG: "log",
  ERROR: "error",
  WARNING: "warn",
};

export const STATS_SCREEN_CONSTANTS = {
  DASHBOARD_STATS: "DASHBOARD_STATS",
  FINANCE_STATS: "FINANCE_STATS",
  SALES_SUMMARY_STATS: "SALES_SUMMARY_STATS",
};

export const NO_NESTED_SIDEBAR_ROUTES = [
  routesPathConstants.CUSTOMERS,
  routesPathConstants.DASHBOARD,
  routesPathConstants.PRINTER_SETTINGS,
  routesPathConstants.BILLING,
  routesPathConstants.PAYOUTS,
  routesPathConstants.USER_INFORMATION,
  routesPathConstants.CUSTOMERS_EDIT,
  routesPathConstants.CUSTOMERS_ADD,
  routesPathConstants.SETTINGS_USERS,
  routesPathConstants.SETTINGS_USERS_EDIT_USER,
  routesPathConstants.ADD_NEW_USER,
  routesPathConstants.ORDERS,
];

export const PUBSUB_MESSAGE_TYPES = {
  SHOPIFY_ORDER_NOTIFICATION: "SHOPIFY_ORDER_NOTIFICATION",
  CUSTOMER_SYNC_WITH_SHOPIFY: "CUSTOMER_SYNC_WITH_SHOPIFY",
  SHOPIFY_INTEGRATION_DISABLED: "SHOPIFY_INTEGRATION_DISABLED",
  AUDIT_INITIALIZED: "AUDIT_INITIALIZED",
  AUDIT_COMPLETED: "AUDIT_COMPLETED",
  INVENTORY_ADDED: "INVENTORY_ADDED",
  ACTIVATE_SPINNER: "ACTIVATE_SPINNER",
  DEACTIVATE_SPINNER: "DEACTIVATE_SPINNER",
};

export const PAGE_END_RECORD = 999998;

export const TABLE_IDS = {
  SETTINGS_USERS: "settingsUsers",
  SETTINGS_TRADE_INS: "settingsTradeIns",
  SETTINGS_SHOPIFY_PRESETS: "settingsShopifyPresets",
  SETTINGS_PRESET_PRICES: "settingsPresetPrices",
  SETTINGS_DISCOUNTS: "settingsDiscounts",
  SETTINGS_DEVICES: "settingsDevices",

  REGISTER_SESSIONS: "registerSessions",
  CASH_MANAGEMENT: "cashManagement",
  ORDERS: "orders",
  ADD_TRADE_BATCH: "addTradeBatch",
  SELL_TRADE_DRAFTS: "sellTradeDrafts",

  STOCK_AUDIT_BREAKDOWN: "stockAuditBreakdown",
  STOCK_AUDIT_SESSION: "stockAuditSession",
  STOCK_AUDIT: "stockAudit",
  STOCK_AUDIT_LIST: "stockAuditList",

  PRICE_CHANGES: "priceChanges",
  EDIT_PRICE_MODAL: "editPriceModal",
  CHANGE_PRICE_LIST: "changePriceList",

  INVENTORY: "inventory",
  EDIT_BATCH_INVENTORY: "editBatchInventory",
  INVOICES: "invoices",
  ADD_INVOICE_BATCH: "addInvoiceBatch",
  ADD_BATCH_INVENTORY: "addBatchInventory",
  SEARCH_COMPANY_INVENTORY: "searchCompanyInventory",
  ITEM_HISTORY: "itemHistory",
  TRANSACTION_HISTORY: "transactionHistory",
  ADMIN_STORES: "adminStores",
  ADMIN_SYSTEM_USERS: "adminSystemUsers",
  ADMIN_DEVICES: "adminDevices",
  ADMIN_COMPANIES: "adminCompanies",
  CUSTOMERS: "customers",
  INVENTORY_HISTORY: "inventoryHistory",
};
export const TABLE_COLUMNS = {
  ACTION_ID: "action",
  ACTION_NAME: "Action",
};
